import { render, staticRenderFns } from "./GoodsTab.vue?vue&type=template&id=3a0b1bf6&scoped=true&"
import script from "./GoodsTab.vue?vue&type=script&lang=js&"
export * from "./GoodsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b1bf6",
  null
  
)

export default component.exports